import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { MeERPSlice, nextMeERPRequestKey, OverviewKey } from "./MeERPInterface";

import { MeERPScreenId } from "./MeERPScreenScaffold";

interface OverviewCard { key: OverviewKey; label: string; screen: MeERPScreenId }
interface MeERPOverviewProps {
  onEvent: (event: { message: "GetMeERPOverview"; params: { requestKey: number } }) => void;
  meerp: MeERPSlice;
  onNavigate: (screen: MeERPScreenId) => void;
}

const CARDS: OverviewCard[] = [
  { key: "requests", label: "MEERP_OVERVIEW_PENDING_MR", screen: "PR01" },
  { key: "orders", label: "MEERP_OVERVIEW_PENDING_PO", screen: "GR01" },
  { key: "receipts", label: "MEERP_OVERVIEW_PENDING_GR", screen: "GR01" },
  { key: "documents", label: "MEERP_OVERVIEW_PENDING_DOCUMENT", screen: "RP01" },
];
const emptyEntry = () => ({ count: null, errorId: null });

const MeERPOverview: React.FC<MeERPOverviewProps> = ({ onEvent, meerp, onNavigate }) => {
  const intl = useIntl();
  const [requestKey, setRequestKey] = useState(() => nextMeERPRequestKey());

  useEffect(() => {
    onEvent({ message: "GetMeERPOverview", params: { requestKey } });
    // The parent remounts this screen when the division/client context changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const overview = meerp.overview;
  const current = overview.requestKey === requestKey;
  const summary = current ? overview.summary : null;
  const loading = !current || overview.loading;

  const refresh = () => {
    const key = nextMeERPRequestKey();
    setRequestKey(key);
    onEvent({ message: "GetMeERPOverview", params: { requestKey: key } });
  };
  return <>
    <div className="card-meerp__page-heading">
      <div><h2>{intl.formatMessage({ id: "MEERP_SCREEN_ER00" })}</h2></div>
      <button type="button" className="card-meerp__button card-meerp__secondary" onClick={refresh}>{intl.formatMessage({ id: "MEERP_REFRESH" })}</button>
    </div>
    <p className="card-meerp__muted">{intl.formatMessage({ id: "MEERP_OVERVIEW_LIVE_NOTE" })}</p>
    <div className="card-meerp__modules" aria-busy={loading}>
      {CARDS.map((card) => {
        const result = summary ? summary[card.key] : emptyEntry();
        return <button type="button" className="card-meerp__module" key={card.key} onClick={() => onNavigate(card.screen)}>
          <strong>{intl.formatMessage({ id: card.label })}</strong>
          <span className="card-meerp__summary-value">{result.count === null ? "—" : intl.formatNumber(result.count)}</span>
          <span>{result.errorId ? intl.formatMessage({ id: result.errorId }) : loading && result.count === null ? intl.formatMessage({ id: "MEERP_LOADING" }) : intl.formatMessage({ id: "MEERP_OVERVIEW_COUNT_NOTE" })}</span>
        </button>;
      })}
    </div>
  </>;
};

export default MeERPOverview;
